import { WorkflowBuilder, WorkflowUnitBuilder } from "./builder";
import AddonConfigurationUnit from "./units/addonConfiguration";
import DocumentGenerationUnit from "./units/documentGeneration";
import InitializationUnit, { collectSfParams } from "./units/initialization";
import PhaseConfigurationUnit from "./units/phasesConfiguration";
import ProductSelectionUnit from "./units/productSelection";
var SF_WORKFLOW_ID = "salesforce";
var SalesforceInitializationUnit = new WorkflowUnitBuilder().template(InitializationUnit).prepend(collectSfParams).build();
var SalesforceWorkflow = new WorkflowBuilder().id(SF_WORKFLOW_ID).with([
    SalesforceInitializationUnit,
    ProductSelectionUnit,
    AddonConfigurationUnit,
    PhaseConfigurationUnit,
    DocumentGenerationUnit, 
]).build();
export default SalesforceWorkflow;
